import { useLocalObservable } from 'mobx-react-lite';
import React, { createContext } from 'react';

import { useDraftTimelogStore } from '@/features/draftTimelogs';
import { useStrictContext } from '@/hooks/useStrictContext';
import { useTimeLogStore } from '@/pages/TimesheetsPage/model';

import { TimeStatsModel } from './TimeStatsModel';

interface ProviderProps {
  children: React.ReactNode;
}

const TimeStatsContext = createContext<TimeStatsModel | null>(null);

export const TimeStatsProvider: React.FC<ProviderProps> = ({ children }) => {
  const timeLogStore = useTimeLogStore();
  const draftTimelogStore = useDraftTimelogStore();
  const timeStatsModel = useLocalObservable(
    () => new TimeStatsModel(timeLogStore, draftTimelogStore),
  );

  return <TimeStatsContext.Provider value={timeStatsModel}>{children}</TimeStatsContext.Provider>;
};

export function useTimeStatsModel() {
  const store = useStrictContext({
    context: TimeStatsContext,
    message: 'useTimeStatsModel must be used within TimeStatsProvider',
  });

  return store;
}
